import { useEffect, useState, useRef, useCallback } from 'react';

const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);
  // Cache scrollHeight to avoid forced reflow on every scroll
  const cachedTotalHeightRef = useRef(0);

  const updateCachedHeight = useCallback(() => {
    cachedTotalHeightRef.current = document.documentElement.scrollHeight - window.innerHeight;
  }, []);

  useEffect(() => {
    // Initial calculation
    updateCachedHeight();

    const handleScroll = () => {
      const totalHeight = cachedTotalHeightRef.current;
      if (totalHeight <= 0) return;
      const scrollPosition = window.scrollY;
      const currentProgress = (scrollPosition / totalHeight) * 100;
      setProgress(currentProgress);
    };

    const handleResize = () => {
      updateCachedHeight();
      handleScroll();
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [updateCachedHeight]);

  return (
    <>
      {/* Top progress bar — sitzt unter der StatusBar, daher gekoppelt an
          --statusbar-h statt hart auf top-0. */}
      <div
        aria-hidden="true"
        style={{ top: 'var(--statusbar-h, 0px)' }}
        className="fixed left-0 right-0 h-[2px] bg-secondary/30 z-[55]"
      >
        <div
          className="h-full bg-gradient-to-r from-primary via-gold to-primary transition-all duration-150 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Side progress indicator.
          Erst ab 2 % Scroll im DOM: bei Scroll-Position 0 stand sonst dauerhaft
          ein "0 %" am rechten Rand — das las sich wie ein hängengebliebener
          Ladeindikator, nicht wie ein Fortschrittsbalken.
          Bewusst unmounten statt nur `opacity-0`: ein transparentes Element
          bleibt für Screenreader-Heuristiken und Hit-Testing vorhanden.
          Die Prozentzahl ist ganz raus — eine exakte Zahl am Bildrand liest
          sich wie ein Ladezähler; der Balken zeigt die Position genauso gut.
          aria-hidden, weil rein dekorativ. */}
      {progress > 2 && (
        <div
          aria-hidden="true"
          className="fixed right-8 top-1/2 -translate-y-1/2 z-50 hidden lg:block animate-fade-in"
        >
          <div className="w-[2px] h-32 bg-secondary/30 rounded-full overflow-hidden">
            <div
              className="w-full bg-primary transition-all duration-150 ease-out rounded-full"
              style={{ height: `${progress}%` }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ScrollProgress;
